import PropTypes from "prop-types";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "components/Button";
import { Dropdown } from "components/Dropdown";
import { startStrategyOptions } from "./options";
import { buttonTextHandlerV2 } from "features/Strategy/utils";
import {
  StrategyActionContainer,
  TooltipContent,
} from "./StrategyAction.styles";
import { contains, isFreeUser } from "utils/index";
import { iconPremiumLock1, PauseBotV2, StartBotV2 } from "assets/icons/index";
import { Tooltip } from "components/Tooltip";
import {
  setShowFeatureDetailsKey,
  setWalkthrough,
  togglePurchasePlanModal,
} from "Layout/slice/index";
import { welcomeWalkthroughSelect } from "Layout/slice/selector";
import { useEffect } from "react";

const StrategyAction = ({
  rowData = null,
  index,
  handleStartStrategy,
  handleStopStrategy,
  handlePauseStrategy,
  handleChangeAllocationAmount,
  handleManageAllocation,
}) => {
  const dispatch = useDispatch();
  const isWelcomeWalkthrough = useSelector(welcomeWalkthroughSelect);

  const { subscription_status, eligible, broker_key } = rowData;

  const isSurmountPaper = broker_key === "SURMOUNT";
  const isFreePlan = isFreeUser();

  const buttonText = buttonTextHandlerV2(
    subscription_status,
    isSurmountPaper,
    isFreePlan
  );

  const buttonActionHandler = {
    start: () => handleStartStrategy(rowData),
    pause: () => handlePauseStrategy(rowData),
    stop: () => handleStopStrategy(rowData),
    allocationAmount: () => handleChangeAllocationAmount(rowData),
    manageStrategies: () => handleManageAllocation(rowData),
  };

  useEffect(() => {
    if (isWelcomeWalkthrough) {
      setTimeout(() => {
        dispatch(setShowFeatureDetailsKey("investStrategy"));
        dispatch(setWalkthrough({ run: true, stepIndex: 0, scrollTo: false }));
      }, 500);
    }
  }, []);

  const handleClick = (id) => {
    return buttonActionHandler[id]();
  };

  const showDropdown = () => {
    if (subscription_status === "Paused" || subscription_status === "Active") {
      return true;
    }

    return false;
  };

  const getButtonIcon = (id) => {
    switch (id) {
      case "lock":
        return (
          <img
            src={iconPremiumLock1}
            alt="start-strategy"
            className="start-icon"
          />
        );
      case "pause":
        return <PauseBotV2 className="start-icon" />;
      default:
        return <StartBotV2 className="start-icon" />;
    }
  };

  const handleUpgrade = () => {
    dispatch(togglePurchasePlanModal(true));
  };

  const UpgradeTooltipContent = () => (
    <TooltipContent className="content">
      <div>
        <span className="content-line">
          To unlock this feature you need to upgrade
        </span>
        Surmount premium subscription
      </div>
      <div className="w-100">
        <Button className="upgrade-btn" onClick={handleUpgrade}>
          Upgrade now
        </Button>
      </div>
    </TooltipContent>
  );

  return (
    <StrategyActionContainer
      className={classNames({
        "show-dropdown": showDropdown(),
      })}
    >
      {isFreePlan && !isSurmountPaper ? (
        <Tooltip
          value={<UpgradeTooltipContent />}
          placement="bottom"
          tooltipClassName="premium-tooltip"
          delay={2000}
        >
          <img
            src={iconPremiumLock1}
            alt="premium-lock"
            className="lock-icon"
          />
        </Tooltip>
      ) : (
        <>
          {startStrategyOptions(subscription_status).length > 0 ? (
            <Dropdown
              className="strategy-control-actions"
              size="small"
              options={startStrategyOptions(subscription_status)}
              onOptionClick={(option) => handleClick(option.key)}
              divider={false}
              title={
                <div
                  type="button"
                  className="dropdown-toggle dropdown-toggle-split btn btn-primary start-list-options-menu"
                ></div>
              }
              disabled={!eligible}
            >
              <Button
                className="dropdown-btn"
                disabled={!eligible}
                onClick={() => handleClick(buttonText.id)}
              >
                {getButtonIcon(buttonText.id)}
                <span>{buttonText.title}</span>
              </Button>
            </Dropdown>
          ) : (
            <Button
              className={classNames("dropdown-btn", {
                "wt-btn-invest-start":
                  index === 0 && contains(buttonText.title, "Start"),
              })}
              onClick={() => handleClick(buttonText.id)}
              disabled={!eligible}
            >
              {/* <img
                src={getButtonIcon(buttonText.id)}
                alt="start-strategy"
                className="start-icon"
              />{" "} */}

              {getButtonIcon(buttonText.id)}
              <span>{buttonText.title}</span>
            </Button>
          )}
        </>
      )}
    </StrategyActionContainer>
  );
};

export default StrategyAction;

StrategyAction.propTypes = {
  rowData: PropTypes.object,
  handleStartStrategy: PropTypes.func,
  handleStopStrategy: PropTypes.func,
  handlePauseStrategy: PropTypes.func,
  handleChangeAllocationAmount: PropTypes.func,
  handleManageAllocation: PropTypes.func,
  index: PropTypes.number,
};
